import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Global } from '../../global/global';
import { User } from '../../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {


  constructor(
    private httpClient: HttpClient
  ) { }

  public getUserStorage(): User {
    let obj = JSON.parse(localStorage.getItem("user")!);
    return new User(obj.id, obj.name, obj.email, obj.initialSetup, obj.avatarId, obj.country, obj.statusMessage);
  }

  public saveUserStorage(user: User){
    localStorage.setItem("user", JSON.stringify(user));
  }

  public deleteUserStorage(){
    localStorage.removeItem("user");
  }

  public getUserByHttp(): Observable<User> {
    return this.httpClient.get<User>(Global.BASE_API_URL + "/api/user");
  }

  public updateUser(req: any){
    return this.httpClient.put<User>(Global.BASE_API_URL + "/api/user", req);
  }

  public deleteUser(){
    return this.httpClient.delete(Global.BASE_API_URL + "/api/user");
  }

  public setStatusMessage(req: string){
    return this.httpClient.put(Global.BASE_API_URL + "/api/user/status/message", req, {responseType: 'text'});
  }
}
